import ChangePasswordRequestModelBase from '../_generated/modelBases/change-password-request-model-base';

export default class ChangePasswordRequestModel extends ChangePasswordRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
